import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
const menuDataOne = [
  { title: 'About Us', href: '/about' },
  // { title: 'Services', href: '/departments' },
  { title: 'Gallery', href: '/gallery' },
   { title: 'Contact Us', href: '/contact' },
  // { title: 'Doctors', href: '/doctors' },
  // { title: 'Timetable', href: '/timetable' },
  // { title: 'Appointment', href: '/appointments' },
  // { title: 'Testimonials', href: '/testimonials' },
];

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: 'url(/images/logo.png)' }}
        >
          
          {/* <h2 className="cs_footer_brand_text">Precision Ortho CAD</h2> */}
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text="Precision Ortho CAD" />
                <ContactInfoWidget />
              </div>
            </div>
            <div className="col-lg-4 d-flex justify-content-center">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataOne} />
              </div>
            </div>
            
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title="Be Our Subscribers"
                  subTitle="To get the latest news about health from our experts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            {/* <div className="cs_copyright">
              Copyright © 2026 Precision Ortho CAD. All rights reserved. Developed by YRP IT Solutions.
            </div> */}
            <div className="cs_copyright">
               Copyright © 2026 Precision Ortho CAD. All rights reserved. Developed by{" "}
              <a
                href="https://www.yrpitsolutions.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "inherit",
                  textDecoration: "none",
                  fontWeight: "600",
                }}
              >
                YRP IT Solutions
              </a>
</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
